import React from 'react';
import { TOTAL_ENDINGS } from '../data/endings';
import { useI18n } from '../i18n';

export default function TitleScreen({ onStart, save, accent }) {
  const { t } = useI18n();
  return (
    <div className="screen title">
      <div className="title__brand">
        <div className="title__eyebrow">{t.ui.titleEyebrow}</div>
        <h1 className="title__h1">
          <img
            src={`${process.env.PUBLIC_URL}/newpmlogo.png`}
            alt="thenew.pm"
            className="title__logo"
          />
        </h1>
        <p className="title__sub">{t.ui.titleSub}</p>
      </div>
      <div className="title__deck">
        <div className="title__cardstack">
          <div className="title__card title__card--3" style={{ background: '#FCF3DF' }} />
          <div className="title__card title__card--2" style={{ background: '#FFC5F6' }} />
          <div className="title__card title__card--1" style={{ background: accent }} />
        </div>
      </div>
      <button
        className="title__cta"
        onClick={onStart}
        style={{ background: accent, color: accent === '#FDBC45' ? '#000' : '#fff' }}
      >
        {t.ui.titleCta}
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor"
             strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M5 12h14M13 6l6 6-6 6" />
        </svg>
      </button>
      <div className="title__meta">
        <div className="title__metaitem">
          <span className="title__mlbl">{t.ui.titleBest}</span>
          <span className="title__mval">{save.highScore} {t.ui.titleDays}</span>
        </div>
        <div className="title__metaitem">
          <span className="title__mlbl">{t.ui.titleEndings}</span>
          <span className="title__mval">{save.unlocked.length} / {TOTAL_ENDINGS}</span>
        </div>
      </div>
      <p className="title__credits">
        {t.ui.creditsBy}{' '}
        <a
          href="https://www.linkedin.com/in/baptiste-hediard/"
          target="_blank"
          rel="noreferrer"
          className="title__credits-link"
        >
          Baptiste Hediard
        </a>
        <br />
        {t.ui.creditsTagline}
      </p>
    </div>
  );
}
